import React from 'react';

import * as s from './AuthorOpinionDisclaimer.css';

/**
 * Компонент "Мнение автора"
 */
export const AuthorOpinionDisclaimer = () => (
  <p id={'author-opinion-disclaimer'} className={s['wrapper']}>
    Мнение автора может не совпадать с мнением редакции
  </p>
);
